import { LOGOUT } from '../../actions/auth';

import {
  FETCH_MY_PLACEMENT_SENT,
  FETCH_MY_PLACEMENT_SUCCEEDED,
  FETCH_MY_PLACEMENT_FAILED,
} from '../../actions/placement';

const initialState = {
  placement: null,
  loading: false,
  loaded: false,
};

export default function placementReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case LOGOUT:
      return initialState;
    case FETCH_MY_PLACEMENT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loaded: true,
        placement: payload.placement,
      };
    case FETCH_MY_PLACEMENT_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MY_PLACEMENT_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
